import React, { useState } from 'react';
import ReactCountryFlag from 'react-country-flag';

const Header = ({ language, onToggleLanguage }) => {
  const [open, setOpen] = useState(false);
  const texts = {
    lt: {
      nav: [
        { href: '#section-1', label: 'Pradžia' },
        { href: '#section-2', label: 'Takeliai' },
        { href: '#section-3', label: 'Eiga' },
        { href: '#section-4', label: 'Pastaba' },
      ],
      cta: 'Tęsti',
      menu: 'Meniu',
      close: 'Uždaryti',
      languageLabel: 'English',
      flag: 'GB',
    },
    en: {
      nav: [
        { href: '#section-1', label: 'Home' },
        { href: '#section-2', label: 'Lanes' },
        { href: '#section-3', label: 'Path' },
        { href: '#section-4', label: 'Note' },
      ],
      cta: 'Continue',
      menu: 'Menu',
      close: 'Close',
      languageLabel: 'Lietuvių',
      flag: 'LT',
    },
  };

  const t = texts[language];

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-ink/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
        <a href="#section-1" className="font-heading text-2xl tracking-wide text-paper">
          Filmviewing
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {t.nav.map((item) => (
            <a key={item.href} href={item.href} className="text-sm text-sand transition hover:text-paper">
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onToggleLanguage}
            className="flex items-center gap-2 border border-white/15 px-3 py-2 text-sm text-paper"
            aria-label={t.languageLabel}
          >
            <ReactCountryFlag countryCode={t.flag} svg style={{ width: '1.35em', height: '1em' }} />
            <span>{t.languageLabel}</span>
          </button>
          <a href="/s" className="hidden bg-amber px-4 py-2 text-sm font-medium text-ink sm:inline-block">
            {t.cta}
          </a>
          <button
            type="button"
            className="border border-white/15 px-3 py-2 text-sm md:hidden"
            onClick={() => setOpen((value) => !value)}
          >
            {open ? t.close : t.menu}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-white/10 px-5 py-4 md:hidden">
          <div className="flex flex-col gap-4">
            {t.nav.map((item) => (
              <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="text-sand">
                {item.label}
              </a>
            ))}
            <a href="/s" className="bg-amber px-4 py-3 text-center font-medium text-ink">
              {t.cta}
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
